export default __webpack_public_path__ + "static/hustler-europe-site-fe369fc0f4649640ec2e9f87df355633.mp4";